import SellerBlock from './seller-block';
export default SellerBlock;